import styles from "./StartNewVideo.module.css"
import { useNavigate } from "react-router-dom";

const StartNewVideo = () => {
  const navigate = useNavigate();
  
  const handleBackClick = () => {
    navigate("/");
  };
  
  const handleGenerateClick = () => {
    navigate("/videos/new");
  };
  return (
    <div className={styles.container}>
      {/* Back Arrow */}
      <div className={styles.backArrowContainer}>
        <svg
          className={styles.arrowIcon}
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          onClick={handleBackClick}
          style={{ cursor: 'pointer' }}
        >
          <path d="M19 12H5M12 19l-7-7 7-7" />
        </svg>
      </div>

      {/* Main Content */}
      <main className={styles.main}>
        {/* Banner Image */}
        <div className={styles.bannerContainer}>
          <img
            src="/TopNewVideo.png"
            alt="Abstract art banner"
            className={styles.bannerImage}
          />
        </div>

        {/* Title Section */}
        <div className={styles.titleSection}>
          <div className={styles.titleContainer}>
            <h1>Get started with Ratava</h1>
            <p className={styles.subtitle}>Choose how you'd like to create your videos</p>
          </div>
        </div>

        {/* Options */}
        <div className={styles.optionsContainer}>
          {/* High Production Value Option */}
          <div className={styles.optionSection}>
            <h2>High production value</h2>
            <div className={styles.optionCard}>
              <div className={styles.optionImageContainer}>
                <img
                  src="/BottomNewVideo.png"
                  alt="Professional video production illustration"
                  className={styles.optionImage}
                />
              </div>
              <div className={styles.optionContent}>
                <div>
                  <div className={styles.optionMeta}>1-7 Days, 100-500 credits</div>
                  <h3 className={styles.optionTitle}>Request production</h3>
                  <p className={styles.optionDescription}>
                    Best for high quality presentations, training and compliance videos, and advertisements
                  </p>
                </div>
                <div className={styles.optionButtonContainer}>
                  <button 
                    className={styles.actionButton}
                    onClick={() => navigate("/tickets/new")}
                    >
                      Request production
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* Quick and Easy Option */}
          <div className={styles.optionSection}>
            <h2>Quick and easy</h2>
            <div className={styles.optionCard}>
              <div className={styles.optionImageContainer}>
                <img
                  src="/MiddleNewVideo.png"
                  alt="People taking selfie illustration"
                  className={styles.optionImage}
                />
              </div>
              <div className={styles.optionContent}>
                <div>
                  <div className={styles.optionMeta}>5-30 minutes, 1-5 credits</div>
                  <h3 className={styles.optionTitle}>Generate yourself</h3>
                  <p className={styles.optionDescription}>
                    Best for quick generation for friends or email with single shots
                  </p>
                </div>
                <div className={styles.optionButtonContainer}>
                  <button 
                    className={styles.actionButton}
                    onClick={handleGenerateClick}
                  >
                    Generate
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  )
}

export default StartNewVideo
